import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";
import { useState } from "react";

export default function ProfilePicker({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const [selectedProfile, setSelectedProfile] = useState(null);    
   
    const selectProfile = (profileId) => {
        if (loading) return;
        setError("");
        closeBottomSheetMenu();
        next({
            action: "select_profile",
            profileId
        });
    };

    const editProfile = (profileId) => {
        if (loading) return;
        setError("");
        next({
            action: "edit_profile",
            profileId
        });
    };

    const removeProfile = (profileId) => {
        if (loading) return;
        setError("");
        next({
            action: "remove_profile",
            profileId
        });
    };

    const createProfile = () => {
        if (loading) return;
        setError("");
        next({
            action: "create_profile"
        });
        //Backend creates a new profile and returns currentStep = DOB, profile = newly created profile
    };
    
    const openBottomSheetMenu = (profile) => {
        if (loading) return;
        setError("");
        setSelectedProfile(profile);
    };

    const closeBottomSheetMenu = () => {
        if (loading) return;
        setError("");
        setSelectedProfile(null);
    };
    
    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-header">
                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>
            </div>

            <div className="page-content">
                <h3 className="form-title">
                    Who is this waiver for?
                </h3>
                <p className="profile-subtitle">
                    Select the person receiving the service.
                </p>                
                   
                {flowContext.customerProfiles?.map(profile => (  //check if backend returns: flowContext.profiles
                <div
                    key={profile._id}
                    className="profile-card"
                    onClick={() => selectProfile(profile._id)}
                >
                    <div className="profile-avatar">
                        {profile.firstName?.[0]}
                        {profile.lastName?.[0]}
                    </div>
                    <div className="profile-details">
                        <div className="profile-name">
                            {profile.firstName} {profile.lastName}
                        </div>
                        <div className="profile-status">
                            {!profile.isProfileComplete
                                ? "Complete profile to proceed"
                                : profile.requiresGuardianConsent
                                    ? "Guardian consent required"
                                    : profile.isMinor && profile.minorWaiverAllowed === false
                                        ? "Minor not allowed for this waiver"
                                        : "Ready to sign"}
                        </div>
                    </div>
                    <div className="profile-menu">
                        <button
                            className="profile-menu"
                            disabled={loading}
                            onClick={(e) => {
                                e.stopPropagation();
                                 openBottomSheetMenu(profile);
                            }}
                        >
                            •••
                        </button>
                    </div>                

                    <div className="profile-arrow">
                        ›
                    </div>

                </div>
                ))} 

                {selectedProfile && (
                     <div
                        className="profile-bottom-sheet-backdrop"
                        onClick={closeBottomSheetMenu}
                    >                    
                        <div 
                            className="profile-bottom-sheet"
                            onClick={(e) => e.stopPropagation()}
                        >

                            <button
                                onClick={() => {
                                    closeBottomSheetMenu();
                                    editProfile(selectedProfile._id);
                                }}
                                disabled={loading}
                            >
                                Edit Profile
                            </button>

                            <button
                                className="danger"
                                onClick={() => {
                                    closeBottomSheetMenu();
                                    removeProfile(selectedProfile._id);
                                }}
                                disabled={loading}
                            >
                                Delete Profile
                            </button>

                            <button
                                onClick={closeBottomSheetMenu}
                            >
                                Cancel
                            </button>

                        </div>
                    </div>
                )}


                <div
                    className="profile-card profile-add-card"
                    onClick={createProfile}
                    disabled={loading}
                >

                    <div className="profile-avatar">
                        +
                    </div>

                    <div className="profile-details">

                        <div className="profile-name">
                            Add new client
                        </div>

                        <div className="profile-status">
                            Set up a new person to sign
                        </div>

                    </div>

                </div>

            </div>

            <div className="page-footer">

                <div className="powered-by">
                    Powered by <strong>DidYouSign</strong>
                </div>

            </div>

        </div>
    );
}